import { render, staticRenderFns } from "./ShortStayDetails.vue?vue&type=template&id=2687f29c&"
import script from "./ShortStayDetails.vue?vue&type=script&lang=js&"
export * from "./ShortStayDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports